import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class CalendarComuService {

  @Output() readonly getDataCalendarEvent: EventEmitter<any> = new EventEmitter();
  @Output() readonly searchEvents: EventEmitter<any> = new EventEmitter();
  @Output() readonly searchPlanningDayEvents: EventEmitter<any> = new EventEmitter();
  @Output() readonly searchPlanningEvents: EventEmitter<any> = new EventEmitter();
  @Output() readonly returnedCalendarData: EventEmitter<any> = new EventEmitter();
  @Output() readonly eventAdded: EventEmitter<any> = new EventEmitter();
  @Output() readonly removeEvent: EventEmitter<any> = new EventEmitter();
  @Output() readonly eventRemoved: EventEmitter<any> = new EventEmitter();
  @Output() readonly activateInteraction: EventEmitter<any> = new EventEmitter();

  removeEventFromReminders(eventRemovedInput) {
    this.eventRemoved.emit(eventRemovedInput);
  }
}
